import React, { useState, forwardRef } from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { InputDatePickerBetweenStyled } from './styled';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment-timezone';
import { Icons } from 'components';

const toDate = (v) => {
  if (!v) return undefined;
  if (v instanceof Date) return v;
  const d = moment(v).toDate();
  return isNaN(d.getTime()) ? undefined : d;
};

const InputDatePickerBetween = ({
  theme_standard,
  minDate,
  dateFormat,
  showYearPicker,
  showMonthYearPicker,
  showFullMonthYearPicker,
  showQuarterYearPicker,
  showTimeInput,
  showTimeSelect,
  showTimeSelectOnly,
  timeIntervals,
  timeCaption,
  maxDate,
  startDatePlaceholder,
  endDatePlaceholder,
  onChange,
  initialStartDate,
  initialEndDate,
  // errors,
  disabled,
  // label,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [_startDate, _setStartDate] = useState(() => toDate(initialStartDate));
  const [_endDate, _setEndDate] = useState(() => toDate(initialEndDate));

  const ExampleCustomInput1 = forwardRef(({ onClick }, ref) => (
    <button type="button" className="custom_date" onClick={onClick} ref={ref}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div className="show_value" style={{ width: '100%' }}>
          {_startDate
            ? `${moment(_startDate).tz('Asia/Bangkok').format('DD/MM/YYYY')}`
            : startDatePlaceholder}
        </div>
        <div>
          <Icons.ArrowDropDown transform="translate(13 11) rotate(180)" />
        </div>
      </div>
    </button>
  ));

  const ExampleCustomInput2 = forwardRef(({ onClick }, ref) => (
    <button type="button" className="custom_date" onClick={onClick} ref={ref}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div className="show_value" style={{ width: '100%' }}>
          {_endDate
            ? `${moment(_endDate).tz('Asia/Bangkok').format('DD/MM/YYYY')}`
            : endDatePlaceholder}
        </div>
        <div>
          <Icons.ArrowDropDown transform="translate(13 11) rotate(180)" />
        </div>
      </div>
    </button>
  ));

  const _handleChangePicker = (key, value) => {
    switch (key) {
      case 'startDate':
        _setStartDate(value);
        onChange && onChange({ startDate: value, endDate: _endDate });
        break;
      case 'endDate':
        _setEndDate(value);
        onChange && onChange({ startDate: _startDate, endDate: value });
        break;
      default:
        break;
    }
  };

  return (
    <InputDatePickerBetweenStyled>
      <div className={customClass}>
        <div className="date_between_container">
          <DatePicker
            className="date_picker"
            portalId="datepicker-portal"
            popperProps={{ strategy: 'fixed' }}
            selected={_startDate}
            onChange={(e) => {
              _handleChangePicker('startDate', e);
            }}
            // locale={th}
            dateFormat={dateFormat ? dateFormat : 'dd/MMMM/yyyy'}
            showMonthYearPicker={showMonthYearPicker}
            showFullMonthYearPicker={showFullMonthYearPicker}
            showQuarterYearPicker={showQuarterYearPicker}
            showTimeInput={showTimeInput}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnly}
            timeIntervals={timeIntervals}
            showYearPicker={showYearPicker}
            timeCaption={timeCaption}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            customInput={<ExampleCustomInput1 />}
          />

          <DatePicker
            className="date_picker"
            portalId="datepicker-portal"
            popperProps={{ strategy: 'fixed' }}
            selected={_endDate}
            onChange={(e) => {
              _handleChangePicker('endDate', e);
            }}
            // locale={th}
            dateFormat={dateFormat ? dateFormat : 'dd/MMMM/yyyy'}
            showMonthYearPicker={showMonthYearPicker}
            showFullMonthYearPicker={showFullMonthYearPicker}
            showQuarterYearPicker={showQuarterYearPicker}
            showTimeInput={showTimeInput}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnly}
            timeIntervals={timeIntervals}
            showYearPicker={showYearPicker}
            timeCaption={timeCaption}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            customInput={<ExampleCustomInput2 />}
          />
        </div>
      </div>
    </InputDatePickerBetweenStyled>
  );
};

InputDatePickerBetween.propTypes = {};

export default InputDatePickerBetween;
